var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favorit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-111-Copy",
    transform: "translate(10.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.41919,226.059563 C245.789857,227.062897 241.36819,229.63423 238.10619,233.733897 C234.321523,226.332563 227.181523,215.097563 214.989857,207.287897 C218.51319,205.02923 228.06819,200.229563 237.606857,206.977563 C247.01019,213.63223 249.826523,223.48823 250.41919,226.059563",
    id: "Fill-1",
    fill: "#FFA076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11212,254.297657 L56.7664533,254.297657 C55.9334533,253.14709 55.2287867,251.868657 54.7177867,250.44999 C49.98812,237.357423 63.8457867,218.511323 80.9164533,215.51999 C93.58412,213.30099 107.096453,219.97199 115.099787,232.238323 C142.292453,201.46609 180.70612,190.66999 208.66412,203.792657 C210.908787,204.84709 213.015787,206.02099 214.989787,207.287757 C227.181453,215.097657 234.321453,226.332423 238.10612,233.733757 C241.36812,229.634323 245.789787,227.062757 250.41912,226.059657 C255.66212,224.92099 261.17112,225.79809 265.550787,228.74299 C273.411787,234.030323 276.293453,245.087757 272.11212,254.297657",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11212,254.297657 L56.7664533,254.297657 C55.9334533,253.14709 55.2287867,251.868657 54.7177867,250.44999 C49.98812,237.357423 63.8457867,218.511323 80.9164533,215.51999 C93.58412,213.30099 107.096453,219.97199 115.099787,232.238323 C142.292453,201.46609 180.70612,190.66999 208.66412,203.792657 C210.908787,204.84709 213.015787,206.02099 214.989787,207.287757 C227.181453,215.097657 234.321453,226.332423 238.10612,233.733757 C241.36812,229.634323 245.789787,227.062757 250.41912,226.059657 C255.66212,224.92099 261.17112,225.79809 265.550787,228.74299 C273.411787,234.030323 276.293453,245.087757 272.11212,254.297657 Z",
    id: "Stroke-5",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86702,278.007427 L272.116553,278.007427 C276.268253,278.007427 279.63362,272.69956 279.63362,266.151993 C279.63362,259.60466 276.268253,254.296793 272.116553,254.296793 L7.86702,254.296793 C3.71555333,254.296793 0.349953333,259.60466 0.349953333,266.151993 C0.349953333,272.69956 3.71555333,278.007427 7.86702,278.007427 Z",
    id: "Stroke-7",
    stroke: "#1A1A1A",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(165.900000, 87.257333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84064333,73.80772 C2.84267667,56.09282 0.01421,0.0790533333 0.01421,0.0790533333 C0.01421,0.0790533333 14.15351,13.9264533 27.5435767,45.2808533 C35.8098767,64.6372533 35.36141,88.9442867 17.0643433,105.99372 L11.49211,102.58402 C11.49211,102.58402 16.2327433,80.5442867 3.84064333,73.80772",
    id: "Fill-9",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84064333,73.80772 C2.84267667,56.09282 0.01421,0.0790533333 0.01421,0.0790533333 C0.01421,0.0790533333 14.15351,13.9264533 27.5435767,45.2808533 C35.8098767,64.6372533 35.36141,88.9442867 17.0643433,105.99372 L11.49211,102.58402 C11.49211,102.58402 16.2327433,80.5442867 3.84064333,73.80772",
    id: "Stroke-11",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.734277,126.05138 C175.734277,126.05138 176.43241,154.298713 172.75391,163.29558 C167.911077,160.066947 167.911077,159.651147 167.911077,159.651147 L175.734277,126.05138 Z",
    id: "Fill-13",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.540643,111.71846 C102.540643,111.71846 90.6751767,113.714627 90.1207767,102.62546 C89.5663767,91.5362933 105.898543,95.75006 104.718577,87.6550267 C103.53861,79.5602267 90.1069695,75.4036267 90.7157767,67.6826267 C90.7157767,67.6826267 89.4555433,57.7146267 99.6575767,54.2769267 C94.3347767,50.83946 93.33681,38.41936 100.988277,33.7620267 C108.639743,29.10446 117.732743,33.2076267 120.28331,36.0909267 C124.940643,31.1006267 132.75381,26.9976933 139.99181,34.9818933 C147.22981,42.9660933 146.564343,49.50876 140.57631,54.0550267 C141.574277,58.0471267 140.72961,61.5377933 138.213343,62.17666 C135.697077,62.8155267 127.158477,71.17166 127.158477,71.17166 L126.642577,97.0809933 L102.540643,111.71846 Z",
    id: "Fill-15",
    fill: "#25383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.540643,111.71846 C102.540643,111.71846 90.6751767,113.714627 90.1207767,102.62546 C89.5663767,91.5362933 105.898543,95.75006 104.718577,87.6550267 C103.53861,79.5602267 90.1069695,75.4036267 90.7157767,67.6826267 C90.7157767,67.6826267 89.4555433,57.7146267 99.6575767,54.2769267 C94.3347767,50.83946 93.33681,38.41936 100.988277,33.7620267 C108.639743,29.10446 117.732743,33.2076267 120.28331,36.0909267 C124.940643,31.1006267 132.75381,26.9976933 139.99181,34.9818933 C147.22981,42.9660933 146.564343,49.50876 140.57631,54.0550267 C141.574277,58.0471267 140.72961,61.5377933 138.213343,62.17666 C135.697077,62.8155267 127.158477,71.17166 127.158477,71.17166 L126.642577,97.0809933 L102.540643,111.71846 Z",
    id: "Stroke-17",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.085157,195.66309 L110.635723,193.334423 L165.74859,192.44729 C165.74859,192.44729 195.439557,207.14029 199.431657,241.32269 L199.930757,254.296723 L104.619923,254.296723 L104.619923,252.550223 C104.619923,252.550223 90.4535567,215.068957 108.085157,195.66309",
    id: "Fill-19",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.085157,195.66309 L110.635723,193.334423 L165.74859,192.44729 C165.74859,192.44729 195.439557,207.14029 199.431657,241.32269 L199.930757,254.296723 L104.619923,254.296723 L104.619923,252.550223 C104.619923,252.550223 90.4535567,215.068957 108.085157,195.66309 Z",
    id: "Stroke-21",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.79936,192.447243 L110.08116,199.07601 C110.08116,199.07601 111.96626,206.53031 133.922927,205.19961 L133.81186,203.86891 C133.81186,203.86891 142.84956,204.035277 151.11096,201.096677 C159.37236,198.15831 159.99466,196.489277 159.99466,196.489277 L121.447527,195.385843 L110.79936,192.447243 Z",
    id: "Fill-23",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.853557,198.158217 C112.06629,195.99965 85.8704233,126.051217 99.23739,111.82955 C112.604123,97.60765 141.04769,83.6354167 154.520823,83.6354167 C167.99419,83.6354167 174.619923,94.4193833 175.728723,115.488917 C176.837757,136.558217 169.907057,186.84715 162.089223,195.663183 C146.78629,202.150083 117.78809,203.702683 112.853557,198.158217",
    id: "Fill-25",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.853557,198.158217 C112.06629,195.99965 85.8704233,126.051217 99.23739,111.82955 C112.604123,97.60765 141.04769,83.6354167 154.520823,83.6354167 C167.99419,83.6354167 174.619923,94.4193833 175.728723,115.488917 C176.837757,136.558217 169.907057,186.84715 162.089223,195.663183 C146.78629,202.150083 117.78809,203.702683 112.853557,198.158217 Z",
    id: "Stroke-27",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(167.533333, 189.924000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46376667,4.36690333 C9.46376667,4.36690333 5.17953333,8.42130333 3.16376667,3.11927 C2.21013333,0.610703333 5.40936667,0.54117 6.9755,0.31017 C8.19443333,0.130503333 9.82123333,0.0948033333 9.82123333,0.0948033333 C9.82123333,0.0948033333 10.0984333,0.251603333 14.7217,2.86890333 C14.7714,5.57580333 14.3402,7.94973667 11.9193667,9.92187 C9.4983,11.8935367 8.1123,14.1391367 4.36963333,11.6247367 C-0.619033333,8.27337 0.171733333,6.80080333 0.430033333,4.94533667 C0.8351,2.03823667 3.51026667,0.970736667 3.51026667,0.970736667",
    id: "Fill-29",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46376667,4.36690333 C9.46376667,4.36690333 5.17953333,8.42130333 3.16376667,3.11927 C2.21013333,0.610703333 5.40936667,0.54117 6.9755,0.31017 C8.19443333,0.130503333 9.82123333,0.0948033333 9.82123333,0.0948033333 C9.82123333,0.0948033333 10.0984333,0.251603333 14.7217,2.86890333 C14.7714,5.57580333 14.3402,7.94973667 11.9193667,9.92187 C9.4983,11.8935367 8.1123,14.1391367 4.36963333,11.6247367 C-0.619033333,8.27337 0.171733333,6.80080333 0.430033333,4.94533667 C0.8351,2.03823667 3.51026667,0.970736667 3.51026667,0.970736667",
    id: "Stroke-31",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(80.033333, 109.890667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.00784,0.110156667 C-10.5987933,18.90749 -1.55596,78.56429 16.4083733,81.3367567 C34.3727067,84.10899 43.02214,67.6970233 49.2320733,51.5069567 C49.67564,48.5128233 47.6797067,38.0893567 36.92304,35.8715233 C26.3885067,38.4218567 22.0188733,54.3109233 22.0188733,54.3109233",
    id: "Fill-33",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.00784,0.110156667 C-10.5987933,18.90749 -1.55596,78.56429 16.4083733,81.3367567 C34.3727067,84.10899 43.02214,67.6970233 49.2320733,51.5069567 C49.67564,48.5128233 47.6797067,38.0893567 36.92304,35.8715233 C26.3885067,38.4218567 22.0188733,54.3109233 22.0188733,54.3109233",
    id: "Stroke-35",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.928817,146.510653 C116.928817,146.510653 110.52475,154.16212 120.837617,160.399587 C131.150483,166.637287 128.613917,158.320353 128.489083,157.779953 C128.364483,157.23932 121.87735,145.803653 116.928817,146.510653",
    id: "Fill-37",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(118.533333, 121.557333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56767,25.9235667 C11.95187,27.9197333 16.1656367,28.1414 17.8846033,28.1967 C19.6033367,28.2522333 22.09837,26.6998667 20.4349367,24.9256 C22.59747,24.9809 23.6507367,22.1533667 21.4583367,20.4346333 C24.1454033,20.1572 23.6787367,16.1375667 21.4583367,15.3890333 C22.39867,15.3890333 23.3460033,14.8066333 23.5954367,12.8107 C23.84487,10.8147667 20.4349367,9.8168 11.3697033,10.6484 C11.7855033,7.23846667 8.29250333,-1.24483333 4.54983667,0.169166667 C0.807403333,1.58316667 4.21710333,7.82063333 5.04893667,13.4759333 C5.88053667,19.1317 0.225003333,27.8639667 0.141936667,28.1967 C0.141936667,28.1967 -1.52126333,35.4048333 8.01530333,36.4028 C11.2311033,30.4700667 13.1409367,27.5972667 13.1409367,27.5972667",
    id: "Fill-39",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56767,25.9235667 C11.95187,27.9197333 16.1656367,28.1414 17.8846033,28.1967 C19.6033367,28.2522333 22.09837,26.6998667 20.4349367,24.9256 C22.59747,24.9809 23.6507367,22.1533667 21.4583367,20.4346333 C24.1454033,20.1572 23.6787367,16.1375667 21.4583367,15.3890333 C22.39867,15.3890333 23.3460033,14.8066333 23.5954367,12.8107 C23.84487,10.8147667 20.4349367,9.8168 11.3697033,10.6484 C11.7855033,7.23846667 8.29250333,-1.24483333 4.54983667,0.169166667 C0.807403333,1.58316667 4.21710333,7.82063333 5.04893667,13.4759333 C5.88053667,19.1317 0.225003333,27.8639667 0.141936667,28.1967 C0.141936667,28.1967 -1.52126333,35.4048333 8.01530333,36.4028 C11.2311033,30.4700667 13.1409367,27.5972667 13.1409367,27.5972667",
    id: "Stroke-41",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(108.266667, 44.324000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.66007,28.3054333 C23.0501367,36.2341 27.08377,43.2203333 29.2878367,44.7174 C31.0343367,44.842 35.1928033,42.5548667 36.5235033,45.3271 C29.4264367,70.8323 4.58693667,59.5212333 4.58693667,59.5212333 C4.58693667,59.5212333 2.97903667,58.0797 6.30567,56.1390667 C9.63230333,54.1986667 11.68377,42.5548667 6.47203667,35.7352333 C8.63433667,33.6837667 8.37113667,26.4203333 5.66797,21.8876 C1.21853667,21.1390667 -1.90019667,16.3153667 2.00860333,13.6122 C5.91740333,10.9092667 17.4501367,14.7212333 15.2878367,0.139066667 C23.38287,0.305433333 30.31357,2.6341 30.2027367,14.3885 C30.09167,26.1429 23.2165033,30.7449333 12.0720367,31.4659333",
    id: "Fill-43",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.66007,28.3054333 C23.0501367,36.2341 27.08377,43.2203333 29.2878367,44.7174 C31.0343367,44.842 35.1928033,42.5548667 36.5235033,45.3271 C29.4264367,70.8323 4.58693667,59.5212333 4.58693667,59.5212333 C4.58693667,59.5212333 2.97903667,58.0797 6.30567,56.1390667 C9.63230333,54.1986667 11.68377,42.5548667 6.47203667,35.7352333 C8.63433667,33.6837667 8.37113667,26.4203333 5.66797,21.8876 C1.21853667,21.1390667 -1.90019667,16.3153667 2.00860333,13.6122 C5.91740333,10.9092667 17.4501367,14.7212333 15.2878367,0.139066667 C23.38287,0.305433333 30.31357,2.6341 30.2027367,14.3885 C30.09167,26.1429 23.2165033,30.7449333 12.0720367,31.4659333",
    id: "Stroke-45",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.111007,75.6311033 C123.111007,75.6311033 131.289107,76.0469033 131.70514,74.82727 L131.914907,72.7970367 C129.652973,74.0561033 126.56994,74.93157 123.111007,75.6311033",
    id: "Fill-47",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(96.133333, 152.824000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49645333,0.00739666667 C3.49645333,0.00739666667 4.76508667,8.52593 5.91892,11.3774967 C1.41722,13.2310967 0.16982,15.1439633 0.16982,15.1439633",
    id: "Fill-49",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49645333,0.00739666667 C3.49645333,0.00739666667 4.76508667,8.52593 5.91892,11.3774967 C1.41722,13.2310967 0.16982,15.1439633 0.16982,15.1439633",
    id: "Stroke-51",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-56",
    transform: "translate(105.233333, 199.024000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.186596667,0.0520566667 C0.186596667,0.0520566667 6.28943,11.05489 22.81223,11.05489",
    id: "Fill-53",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.186596667,0.0520566667 C0.186596667,0.0520566667 6.28943,11.05489 22.81223,11.05489",
    id: "Stroke-55",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.214677,85.3903167 C144.214677,85.3903167 156.87301,83.38575 149.58391,95.1956833 C142.295043,107.00585 138.13681,110.498617 139.134777,118.649183",
    id: "Stroke-57",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.863443,104.163617 C107.863443,104.163617 105.617843,114.823683 118.56411,114.158217 C128.770577,113.633683 131.926643,121.569117 131.926643,121.569117",
    id: "Stroke-59",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4199,198.72013 C37.4199,198.72013 29.6020667,188.24113 34.2594,185.57973 C38.9169667,182.918097 49.2298333,184.831197 50.3111,198.72013",
    id: "Stroke-61",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#FFFFFF",
    points: "40.3307567 196.342137 50.6436233 254.29677 82.9129233 254.29677 61.6219567 196.584803"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-65",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "40.3307567 196.342137 50.6436233 254.29677 82.9129233 254.29677 61.6219567 196.584803"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#FFFFFF",
    points: "30.6293167 254.145687 35.6732833 196.342253 40.33085 196.342253 50.6434833 254.296653"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-69",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "30.6293167 254.145687 35.6732833 196.342253 40.33085 196.342253 50.6434833 254.296653"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#1A1A1A",
    points: "34.2067833 196.626967 28.24045 254.468667 30.8911167 254.110267 35.6732833 196.342067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7406433,198.054757 C43.7406433,198.054757 34.6751767,179.674857 46.48511,177.17959 C58.2950433,174.684557 56.71491,198.054757 56.71491,198.054757",
    id: "Stroke-73",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#FFFFFF",
    points: "15.9346833 220.260857 17.18185 254.296723 26.24755 254.296723 25.8039833 220.260857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-77",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "15.9346833 220.260857 17.18185 254.296723 26.24755 254.296723 25.8039833 220.260857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0396733,222.70038 C19.0396733,222.70038 17.8198067,211.278713 21.59024,211.057047 C25.36044,210.834913 24.02974,220.26088 24.02974,220.26088",
    id: "Stroke-79",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.693487,245.76573 C218.915387,245.21133 206.439987,230.475397 213.121253,223.37203 C219.802287,216.268663 225.125087,243.215163 224.016287,247.429163 L218.693487,245.76573 Z",
    id: "Fill-81",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.693487,245.76573 C218.915387,245.21133 206.439987,230.475397 213.121253,223.37203 C219.802287,216.268663 225.125087,243.215163 224.016287,247.429163 L218.693487,245.76573 Z",
    id: "Stroke-83",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.004437,246.431103 C230.004437,245.765637 217.362903,210.169703 230.780737,207.841037 C244.19857,205.51237 232.690103,247.42907 232.690103,247.42907 L230.004437,246.431103 Z",
    id: "Fill-85",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.004437,246.431103 C230.004437,245.765637 217.362903,210.169703 230.780737,207.841037 C244.19857,205.51237 232.690103,247.42907 232.690103,247.42907 L230.004437,246.431103 Z",
    id: "Stroke-87",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.770663,246.76379 C235.770663,246.76379 235.299097,224.53529 247.97143,227.588223 C260.643763,230.641157 241.869997,247.429257 241.869997,247.429257 L235.770663,246.76379 Z",
    id: "Fill-89",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.770663,246.76379 C235.770663,246.76379 235.299097,224.53529 247.97143,227.588223 C260.643763,230.641157 241.869997,247.429257 241.869997,247.429257 L235.770663,246.76379 Z",
    id: "Stroke-91",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.97136,245.654757 C247.97136,245.654757 260.277593,226.137823 264.491593,230.24099 C268.70536,234.343923 254.622293,245.654757 254.622293,245.654757 L247.97136,245.654757 Z",
    id: "Fill-93",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.97136,245.654757 C247.97136,245.654757 260.277593,226.137823 264.491593,230.24099 C268.70536,234.343923 254.622293,245.654757 254.622293,245.654757 L247.97136,245.654757 Z",
    id: "Stroke-95",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-97",
    fill: "#FFFFFF",
    points: "213.1213 254.2967 261.026267 254.2967 261.026267 244.2132 213.1213 244.2132"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-99",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "213.1213 254.2967 261.026267 254.2967 261.026267 244.2132 213.1213 244.2132"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-100",
    fill: "#1A1A1A",
    points: "213.1213 246.201667 261.026267 246.201667 261.026267 244.102367 213.1213 244.102367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.696573,3.78039667 C125.696573,4.69039667 125.35124,5.59573 124.65824,6.28873 L123.402907,7.54406333 L118.388573,12.5583967 L112.118907,6.28873 C110.732907,4.90506333 110.732907,2.65806333 112.118907,1.27439667 C112.811907,0.581396667 113.719573,0.23373 114.62724,0.23373 C115.534907,0.23373 116.442573,0.581396667 117.135573,1.27439667 L118.388573,2.52996333 L119.643907,1.27439667 C121.027573,-0.111603333 123.274573,-0.111603333 124.65824,1.27439667 C125.35124,1.96506333 125.696573,2.87506333 125.696573,3.78039667",
    id: "Fill-101",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.696573,3.78039667 C125.696573,4.69039667 125.35124,5.59573 124.65824,6.28873 L123.402907,7.54406333 L118.388573,12.5583967 L112.118907,6.28873 C110.732907,4.90506333 110.732907,2.65806333 112.118907,1.27439667 C112.811907,0.581396667 113.719573,0.23373 114.62724,0.23373 C115.534907,0.23373 116.442573,0.581396667 117.135573,1.27439667 L118.388573,2.52996333 L119.643907,1.27439667 C121.027573,-0.111603333 123.274573,-0.111603333 124.65824,1.27439667 C125.35124,1.96506333 125.696573,2.87506333 125.696573,3.78039667 Z",
    id: "Stroke-102",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.15602,23.9072167 C73.15602,24.8172167 72.8106867,25.72255 72.1176867,26.41555 L70.8623533,27.6708833 L65.84802,32.6852167 L59.5783533,26.41555 C58.1923533,25.0318833 58.1923533,22.7848833 59.5783533,21.4012167 C60.2713533,20.7082167 61.17902,20.36055 62.0866867,20.36055 C62.9943533,20.36055 63.90202,20.7082167 64.59502,21.4012167 L65.84802,22.65655 L67.1033533,21.4012167 C68.48702,20.0152167 70.73402,20.0152167 72.1176867,21.4012167 C72.8106867,22.0918833 73.15602,23.0018833 73.15602,23.9072167",
    id: "Fill-103",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.15602,23.9072167 C73.15602,24.8172167 72.8106867,25.72255 72.1176867,26.41555 L70.8623533,27.6708833 L65.84802,32.6852167 L59.5783533,26.41555 C58.1923533,25.0318833 58.1923533,22.7848833 59.5783533,21.4012167 C60.2713533,20.7082167 61.17902,20.36055 62.0866867,20.36055 C62.9943533,20.36055 63.90202,20.7082167 64.59502,21.4012167 L65.84802,22.65655 L67.1033533,21.4012167 C68.48702,20.0152167 70.73402,20.0152167 72.1176867,21.4012167 C72.8106867,22.0918833 73.15602,23.0018833 73.15602,23.9072167 Z",
    id: "Stroke-104",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.222863,15.0722367 C173.222863,15.9822367 172.87753,16.88757 172.18453,17.58057 L170.929197,18.8359033 L165.914863,23.8502367 L159.645197,17.58057 C158.259197,16.1969033 158.259197,13.9499033 159.645197,12.5662367 C160.338197,11.8732367 161.245863,11.52557 162.15353,11.52557 C163.061197,11.52557 163.968863,11.8732367 164.661863,12.5662367 L165.914863,13.82157 L167.170197,12.5662367 C168.553863,11.1802367 170.800863,11.1802367 172.18453,12.5662367 C172.87753,13.2569033 173.222863,14.1669033 173.222863,15.0722367",
    id: "Fill-105",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.222863,15.0722367 C173.222863,15.9822367 172.87753,16.88757 172.18453,17.58057 L170.929197,18.8359033 L165.914863,23.8502367 L159.645197,17.58057 C158.259197,16.1969033 158.259197,13.9499033 159.645197,12.5662367 C160.338197,11.8732367 161.245863,11.52557 162.15353,11.52557 C163.061197,11.52557 163.968863,11.8732367 164.661863,12.5662367 L165.914863,13.82157 L167.170197,12.5662367 C168.553863,11.1802367 170.800863,11.1802367 172.18453,12.5662367 C172.87753,13.2569033 173.222863,14.1669033 173.222863,15.0722367 Z",
    id: "Stroke-106",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.591053,49.9042833 C211.591053,50.81405 211.24572,51.7193833 210.55272,52.4126167 L209.297387,53.66795 L204.283053,58.6822833 L198.013387,52.4126167 C196.627387,51.0287167 196.627387,48.7817167 198.013387,47.3982833 C198.706387,46.7052833 199.614053,46.3576167 200.52172,46.3576167 C201.429387,46.3576167 202.337053,46.7052833 203.030053,47.3982833 L204.283053,48.6536167 L205.538387,47.3982833 C206.922053,46.01205 209.169053,46.01205 210.55272,47.3982833 C211.24572,48.08895 211.591053,48.99895 211.591053,49.9042833",
    id: "Fill-107",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.591053,49.9042833 C211.591053,50.81405 211.24572,51.7193833 210.55272,52.4126167 L209.297387,53.66795 L204.283053,58.6822833 L198.013387,52.4126167 C196.627387,51.0287167 196.627387,48.7817167 198.013387,47.3982833 C198.706387,46.7052833 199.614053,46.3576167 200.52172,46.3576167 C201.429387,46.3576167 202.337053,46.7052833 203.030053,47.3982833 L204.283053,48.6536167 L205.538387,47.3982833 C206.922053,46.01205 209.169053,46.01205 210.55272,47.3982833 C211.24572,48.08895 211.591053,48.99895 211.591053,49.9042833 Z",
    id: "Stroke-108",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4974233,59.7268233 C41.4974233,60.63659 41.15209,61.5419233 40.45909,62.2351567 L39.2037567,63.49049 L34.1894233,68.5048233 L27.9197567,62.2351567 C26.5337567,60.8512567 26.5337567,58.6042567 27.9197567,57.2208233 C28.6127567,56.5278233 29.5204233,56.1801567 30.42809,56.1801567 C31.3357567,56.1801567 32.2434233,56.5278233 32.9364233,57.2208233 L34.1894233,58.4761567 L35.4447567,57.2208233 C36.8284233,55.83459 39.0754233,55.83459 40.45909,57.2208233 C41.15209,57.91149 41.4974233,58.82149 41.4974233,59.7268233",
    id: "Fill-109",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4974233,59.7268233 C41.4974233,60.63659 41.15209,61.5419233 40.45909,62.2351567 L39.2037567,63.49049 L34.1894233,68.5048233 L27.9197567,62.2351567 C26.5337567,60.8512567 26.5337567,58.6042567 27.9197567,57.2208233 C28.6127567,56.5278233 29.5204233,56.1801567 30.42809,56.1801567 C31.3357567,56.1801567 32.2434233,56.5278233 32.9364233,57.2208233 L34.1894233,58.4761567 L35.4447567,57.2208233 C36.8284233,55.83459 39.0754233,55.83459 40.45909,57.2208233 C41.15209,57.91149 41.4974233,58.82149 41.4974233,59.7268233 Z",
    id: "Stroke-110",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteEmpty);
export default __webpack_public_path__ + "static/media/favorite_empty.43110543.svg";
export { ForwardRef as ReactComponent };